module.exports = __webpack_public_path__ + "img/settings-active.179f8b9c.svg";